import { Injectable } from '@angular/core';

@Injectable()
export class Helpers {
  static getQueryParamsString(paramsObj: Object = {}): string {
    let parts = [];
    for (var i in paramsObj) {
      if (paramsObj.hasOwnProperty(i)) {
        parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(paramsObj[i]));
      }
    }
    return '?' + parts.join("&");
  }

  static getLocation() {
  	return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  }

  static getHttpParams() {
  	return window.location
			.search
			.slice(1)
			.split('&')
			.reduce(function(a: any, b: any) {
			b = b.split('=');
			a[b[0]] = decodeURIComponent(b[1]);
			return a;
			}, {});
  }

  static getCurrentTimestamp() {
    return Date.now();
  }
}


// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/core/utilities/helpers.ts